import {Layer} from '@pixi/layers';

export type Layers = Record<string, Layer>;
